import { entries } from "./entries";
import { Dictionary } from "./types";

export function find<Value = any>(target: Array<Value>, predicate: (key: number, value: Value) => boolean): [number, Value] | null;
export function find<Value = any>(target: Dictionary<Value>, predicate: (key: string, value: Value) => boolean): [string, Value] | null;
export function find<Key extends string | number | symbol, Value = any>(target: Record<Key, Value>, predicate: (key: Key, value: Value) => boolean): [Key, Value] | null;

/**
 * Find index and/or value within an Object or an Array that returns true for the predicate
 */
export function find(target: any, predicate: (key: any, value: any) => boolean) {
	for (const [currentKey, currentValue] of entries(target)) {
		if (predicate(currentKey, currentValue)) return [currentKey, currentValue];
	}

	return null;
}